/** Хелперы для чтения stageList: новый JSON (StageNames) и старый XML-JSON (StageName). */

const toArr = x => {
	if (x == null) return [];
	if (Array.isArray(x)) return x;
	// MobX ObservableArray и другие iterable не проходят Array.isArray
	if (typeof x[Symbol.iterator] === 'function') return [...x];
	return [x];
};

const isNewStageListFormat = stageList =>
	stageList != null && typeof stageList === 'object' && stageList.StageNames != null;

const getStageListRoot = raw => {
	if (raw == null) return null;
	let obj = raw;
	if (typeof raw === 'string') {
		try {
			obj = JSON.parse(raw);
		} catch (e) {
			return null;
		}
	}
	if (!obj || typeof obj !== 'object') return null;
	if (obj.StageNames != null || obj.StageName != null) return obj;
	if (Array.isArray(obj)) return { StageName: obj };
	return null;
};

const getStages = stageList => {
	const sl = getStageListRoot(stageList);
	if (!sl) return [];
	return toArr(sl.StageNames ?? sl.StageName);
};

const getActions = node => toArr(node?.StageActions ?? node?.StageAction);

const getDocListRows = docList => {
	if (docList == null) return [];
	if (Array.isArray(docList)) return docList;
	return toArr(docList.row);
};

const getDocSibName = row => row?.sib_name0 || row?.Sib_Name0 || '';

const getDocUid = row => (row?.DocUID != null ? String(row.DocUID) : null);

const getStageId = stage => stage?.Id ?? stage?.['@Id'] ?? null;

const getActionId = action => action?.Id ?? action?.['@Id'] ?? null;

const getActionDescription = (action, rows = []) => {
	if (action?.ResultOnKomitet) return String(action.ResultOnKomitet).trim();
	if (action?.ResultRassm) return String(action.ResultRassm).trim();
	const row = rows.find(r => r.ResultRassm || r.ResultOnKomitet);
	if (row?.ResultOnKomitet) return String(row.ResultOnKomitet).trim();
	if (row?.ResultRassm) return String(row.ResultRassm).trim();
	return null;
};

const getZasedanieDate = (action, rows = []) => {
	if (action?.Zasedanie_Date) return action.Zasedanie_Date;
	const sa = action?.StageActions ?? action?.StageAction;
	const nested = Array.isArray(sa) ? sa[0] : sa;
	if (nested?.Zasedanie_Date) return nested.Zasedanie_Date;
	const sitting = rows.find(r => getDocSibName(r).toLowerCase() === 'sittings');
	if (sitting?.DocDate) return sitting.DocDate;
	for (const row of rows) {
		if (row.DocDate) return row.DocDate;
	}
	for (const child of getActions(action)) {
		const d = findFirstDocDateDeep(child);
		if (d) return d;
	}
	return null;
};

const findFirstDocDateDeep = node => {
	if (!node) return null;
	for (const row of getDocListRows(node.DocList)) {
		if (row.DocDate) return row.DocDate;
	}
	if (node.DocDate) return node.DocDate;
	for (const child of getActions(node)) {
		const d = findFirstDocDateDeep(child);
		if (d) return d;
	}
	return null;
};

module.exports = {
	toArr,
	isNewStageListFormat,
	getStageListRoot,
	getStages,
	getActions,
	getDocListRows,
	getDocSibName,
	getDocUid,
	getStageId,
	getActionId,
	getActionDescription,
	getZasedanieDate,
	findFirstDocDateDeep,
};
